export default {}.install = (Vue, options = {}) => {
  //自定义指令,按钮级权限控制
  Vue.directive("has", {
    inserted: function (el, binding, vnode) {
      // 获取按钮权限
      let btnPermissions = vnode.context.$route.meta.auth;
      if (!btnPermissions.some(item => item.auth == binding.value)) {
        el.disabled = true
        el.style.cursor = 'not-allowed'
      }
    }
  });
  //自定义指令,el-button只能一次点击
  Vue.directive('clickOnce', {
    inserted(el, binding) {
      el.addEventListener('click', e => {
        if (!el.disabled) {
          el.disabled = true
          el.style.cursor = 'not-allowed'
          el.style.background = '#8FC5FE'
          el.style.borderColor = '#8FC5FE'
        }
      })
    }
  });
    //自定义指令,el-button只能一次点击
    Vue.directive('focus', {
      inserted(el, binding) {
        if(el.querySelector('input')){
          el.querySelector('input').focus()
        }
        if(el.querySelector('textarea')){
          el.querySelector('textarea').focus()
        }

      }
    })
}
